var cbtUtil = require("../cbtUtil");

window.addEventListener("load", function () {
    var dataLayer = $("#checkout-login").data("checkout-login");
    cbtUtil.dataPush(dataLayer);
});
